import { writable } from "svelte/store";
import axios from "axios";
import { push } from "svelte-spa-router";

// for ProgressBar.svelte to subscribe to in order to track the questionnaire progress
export const localStorageQuestionnaireAnswers = writable(JSON.parse(localStorage.getItem('questionnaireAnswers')) || {});

// wrapper for getting items from the local storage which automatically applies JSON.parse
export function getLocalStorageItem(key) {
    return localStorage.getItem(key) == null ? null : JSON.parse(localStorage.getItem(key));
}

// wrapper for setting items in the local storage which automatically applies JSON.stringify and updates localStorageQuestionnaireAnswers
export function setLocalStorageItem(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
    if (key ==='questionnaireAnswers') {
        localStorageQuestionnaireAnswers.set(value);
    }
}

// export const backendURL = 'https://ciipvm2.cit.tum.de/api/'
// export const backendURL = 'http://127.0.0.1:8000/api/'
const build = process.env.BUILD
console.log("BUILD: " + build)

const environments = {
    "production": {
        api_url: "https://ciipvm2.cit.tum.de/api/",
        evaluate_url: "https://ciipvm2.cit.tum.de/evaluate/",
        go_url: "https://ciipvm2.cit.tum.de/api/v2/",
    },
    "development": {
        api_url: "https://ciipvm1.cit.tum.de/api/",
        evaluate_url: "https://ciipvm1.cit.tum.de/evaluate/",
        go_url: "https://ciipvm1.cit.tum.de/api/v2/",
    },
    "local": {
        api_url: "https://ciipvm1.cit.tum.de/api/",
        evaluate_url: "https://ciipvm1.cit.tum.de/evaluate/",
        go_url: "https://ciipvm1.cit.tum.de/api/v2/",
    }
}
console.log(environments);

export const environment = environments[build] ?? environments["local"];
console.log(environment);
export const backendURL = environment.api_url;
export const evaluateURL = environment.evaluate_url;
export const goURL = environment.go_url;

export async function post(address, data) {
    const token = getLocalStorageItem('token');
    const response = await axios.post(backendURL + address, data, {
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json'
        }
    });

    if (response.status >= 300 && response.status < 200) {
        console.log(response.status);
        throw new Error(response.data.detail || 'Request failed');
    }

    answerHighlightsStore = null; // reset answer highlights store as a post request means new answers/user input are submitted

    return await response.data;
}
export async function postEvaluate(address, data) {
    const token = getLocalStorageItem('token');
    const response = await axios.post(evaluateURL + address, data, {
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json'
        }
    });

    if (response.status >= 300 && response.status < 200) {
        console.log(response.status);
        throw new Error(response.data.detail || 'Request failed');
    }

    answerHighlightsStore = null; // reset answer highlights store as a post request means new answers/user input are submitted

    return await response.data;
}


// // cache the questions by putting them in a writable
let questionnaireStore = null;

export async function getQuestionnaire() {
    if (!questionnaireStore) {
        questionnaireStore = await getQuestionnaireData();
        //questionnaireStore = await getData(`get-questionnaire/`);
        console.log(questionnaireStore);
    }

    return questionnaireStore;
}


export const resultEvaluationDone = writable(true);

export async function triggerEvaluation() {
    resultEvaluationDone.set(false);
    await postEvaluate('trigger-evaluation/');
    resultEvaluationDone.set(true);
}


export async function getData(address) {
    const token = getLocalStorageItem('token');
    const response = await axios.get(backendURL + address, {
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json'
        }
    });

    if (response.status != 200) {
        throw new Error(response.data.detail || 'Request failed');
    }

    return await response.data;
}

export async function getQuestionnaireData() {
    const token = getLocalStorageItem('token');
    const response = await axios.get(goURL + `questionnaire`, {
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json'
        }
    });

    if (response.status != 200) {
        throw new Error(response.data.detail || 'Request failed');
    }

    return await response.data;
}


let answerHighlightsStore = null;

export async function getAnswerHighlights() {
    if (!answerHighlightsStore) {
        answerHighlightsStore = await getData(`get-answer-highlights/`);
    }

    return answerHighlightsStore;
}


let loginStatus = null;
let adminStatus = null;

export async function handleLogin(username, password, redirectTo) {
    try {
        const response = await axios.post(backendURL + 'login/', {
            username: username,
            password: password,
        });

        // set authentication token
        setLocalStorageItem('token', response.data.token);
        loginStatus = true;

        try {
            await getData('is-admin/');
            adminStatus = true;
        } catch {
            adminStatus = false;
        }


        const data = await post('get-answers/');
        setLocalStorageItem('questionnaireAnswers', data.questionnaire_answers);

        // redirect, either to originally intended page or home
        if (redirectTo == "") {
            push('/');
        } else {
            push(redirectTo);
        }
    } catch (err) {
        throw new Error('Ungültige Zugangsdaten!');
    }
}


export async function handleLogout() {
    // delete token, answers, etc.
    localStorage.clear();
    document.cookie = "session_id=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
    loginStatus = null;
    adminStatus = null;
    questionnaireStore = null;
}


export async function isLoggedIn() {
    if (loginStatus === null) {
        try {
            await getData('test-token/');
            loginStatus = true;
        } catch {
            loginStatus = false;
        }
    }
    return loginStatus;
}



export async function isAdminUser() {
    if (adminStatus === null) {
        try {
            await getData('is-admin/');
            adminStatus = true;
        } catch {
            adminStatus = false;
        }
    }
    return adminStatus;
}


export async function isGuidedUser() {
    try {
        const response = await getData('is-guided/');
        return true;
    } catch {
        return false;
    }
}

// returns the highest category for which there has been a submission
export async function getQuestionnaireProgress() {
    return await getData('get-questionnaire-progress/');
}
